import * as React from "react";
import { Cookies } from "@grandvisionhq/lib-cookies";
import { onConsentChange } from "../../event.js";
import { EmptyConsent } from "../../types.js";
const CookieConsentContext = React.createContext(EmptyConsent);
CookieConsentContext.displayName = "CookieConsentContext";
const CookieConsentContextProvider = ({
  children,
  cookies,
  consentProvider
}) => {
  const [cookiesState, setCookiesState] = React.useState(cookies);
  React.useEffect(() => {
    setCookiesState(Cookies.get());
    onConsentChange(() => {
      setCookiesState(Cookies.get());
    });
  }, []);
  return /* @__PURE__ */ React.createElement(CookieConsentContext.Provider, { value: consentProvider(cookiesState) }, children);
};
const useCookieConsentContext = () => React.useContext(CookieConsentContext);
export {
  CookieConsentContextProvider,
  useCookieConsentContext
};
//# sourceMappingURL=CookieConsentContext.js.map
